export const BANK_STATUS = {
  VERIFIED: 'Success',
  PENDING: 'Pending',
  FAILED: 'Failed',
  VERIFICATION_ATTEMPTS_EXHAUSTED: 'Verification Attempts Exhausted',
};

export const OCR_VALIDATIONS_PLACEHOLDER = [
  'Must have your name printed',
  'Must show your Account Number',
  'Must show the IFSC',
];

export const BANK_PROOF_DOC_TYPES = [
  { label: 'Cancelled Cheque', value: 'CC' },
  { label: 'Bank Statement', value: 'BS' },
  { label: 'Passbook', value: 'PB' },
];
